import Vue from 'vue';

const success = (response, context) => {
  toastr.success(context.$t('automation.index.modal.notification_sent'));
  context.smallLoading = false;
};


const failed = (error, context) => {
  context.loading = false;
  context.smallLoading = false;
  if (error.response && error.response.data && error.response.data.msg) {
    if (typeof (error.response.data.msg) == 'object') {
      let errors = Object.values(error.response.data.msg);
      for(let error of errors) {
        toastr.error(error);
      }
    } else {
      toastr.error(context.$t('automation.index.modal.notification_fail'));
    }
  }
};

export default (context, data) => {
  context.smallLoading = true;
  return Vue.$http.post('/send-test-notification', data)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/automation/sendTestNotification.js